if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.giftBoxContainer = this.getGiftBoxContainer();
      if (this.giftBoxContainer) this.initGiftBox();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.clearGiftBoxWarning();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      const sectionsPayload = this.getSectionsPayload();
      if (sectionsPayload) {
        formData.append('sections', sectionsPayload.sections);
        formData.append('sections_url', sectionsPayload.sections_url);
        this.cart.setActiveElement(document.activeElement);
      }

      const giftBox = this.getGiftBoxSelection();
      const finalize = () => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      };

      if (giftBox && giftBox.selected && giftBox.variantId) {
        const mainItem = this.getItemFromFormData(formData);
        const giftItem = {
          id: giftBox.variantId,
          quantity: 1,
          properties: {
            _gift_box: giftBox.title || 'Gift Box',
          },
        };

        this.addItems([mainItem, giftItem], sectionsPayload)
          .then((response) => {
            if (response.status) {
              return this.addItems([mainItem], sectionsPayload)
                .then((fallbackResponse) => {
                  if (!fallbackResponse.status) {
                    this.showGiftBoxWarning(
                      'Gift box could not be added. Your main item is in the cart.',
                      giftBox.container
                    );
                  }
                  return fallbackResponse;
                });
            }
            return response;
          })
          .then((response) => {
            if (response) this.processCartResponse(response, formData);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(finalize);

        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.processCartResponse(response, formData);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(finalize);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    processCartResponse(response, formData) {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    }

    getGiftBoxContainer() {
      if (this.dataset.giftBoxTarget) {
        return document.querySelector(this.dataset.giftBoxTarget);
      }
      return this.querySelector('[data-gift-box-upsell]');
    }

    getGiftBoxSelection() {
      const container = this.giftBoxContainer || this.getGiftBoxContainer();
      if (!container || container.dataset.enabled !== 'true') return null;

      const checkbox = container.querySelector('[data-gift-box-checkbox]');
      if (!checkbox || !checkbox.checked) {
        return { container, selected: false };
      }

      let variantId = null;
      const variantInput = container.querySelector('[data-gift-box-variant]');
      if (variantInput) {
        if (variantInput.matches('select')) {
          variantId = variantInput.value;
        } else {
          const checked = container.querySelector('[data-gift-box-variant]:checked');
          variantId = (checked || variantInput).value;
        }
      }
      variantId = variantId || container.dataset.defaultVariantId;

      return {
        container,
        selected: true,
        variantId,
        title: container.dataset.title || 'Gift Box',
      };
    }

    clearGiftBoxWarning() {
      const container = this.giftBoxContainer || this.getGiftBoxContainer();
      if (!container) return;
      const warning = container.querySelector('[data-gift-box-warning]');
      if (!warning) return;
      warning.textContent = '';
      warning.classList.add('hidden');
    }

    showGiftBoxWarning(message, container = null) {
      const target = container || this.giftBoxContainer || this.getGiftBoxContainer();
      if (!target) return;
      const warning = target.querySelector('[data-gift-box-warning]');
      if (!warning) return;
      warning.textContent = message;
      warning.classList.remove('hidden');
    }

    getItemFromFormData(formData) {
      const quantityValue = parseInt(formData.get('quantity'), 10);
      const item = {
        id: formData.get('id'),
        quantity: Number.isNaN(quantityValue) ? 1 : quantityValue,
      };

      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (!value) continue;
        if (key.startsWith('properties[') && key.endsWith(']')) {
          const propName = key.slice(11, -1);
          properties[propName] = value;
        }
      }
      if (Object.keys(properties).length) {
        item.properties = properties;
      }

      const sellingPlan = formData.get('selling_plan');
      if (sellingPlan) {
        item.selling_plan = sellingPlan;
      }

      return item;
    }

    getSectionsPayload() {
      if (!this.cart) return null;
      return {
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };
    }

    addItems(items, sectionsPayload) {
      const payload = Object.assign({ items }, sectionsPayload || {});
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(payload);
      return fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
    }

    initGiftBox() {
      if (!this.giftBoxContainer || this.giftBoxContainer.dataset.giftBoxInitialized === 'true') return;
      this.giftBoxContainer.dataset.giftBoxInitialized = 'true';

      if (this.giftBoxContainer.dataset.needsFetch !== 'true') return;

      const variantInputs = [...this.giftBoxContainer.querySelectorAll('[data-gift-box-variant]')];
      const variantIds = [...new Set(variantInputs.map((input) => input.value).filter(Boolean))];
      if (!variantIds.length) return;

      const moneyFormat = this.giftBoxContainer.dataset.moneyFormat || '{{amount}}';

      Promise.all(
        variantIds.map((id) => fetch(`/variants/${id}.js`)
          .then((response) => response.json())
          .catch(() => null))
      )
        .then((variants) => {
          const validVariants = variants.filter(Boolean);
          if (!validVariants.length) return;

          validVariants.forEach((variant) => {
            const optionLabels = this.giftBoxContainer.querySelectorAll(
              `[data-gift-box-variant][value="${variant.id}"]`
            );
            optionLabels.forEach((input) => {
              const option = input.closest('.gift-box-upsell__option');
              if (!option) return;
              const titleEl = option.querySelector('[data-gift-box-variant-title]');
              const priceEl = option.querySelector('[data-gift-box-variant-price]');
              const title = variant.public_title || variant.title || variant.name;
              if (titleEl && title) titleEl.textContent = title;
              if (priceEl) priceEl.textContent = this.formatMoney(variant.price, moneyFormat);
            });
          });

          const prices = validVariants.map((variant) => variant.price);
          const summaryEl = this.giftBoxContainer.querySelector('[data-gift-box-price-summary]');
          if (summaryEl && prices.length) {
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);
            summaryEl.textContent = minPrice !== maxPrice
              ? `From ${this.formatMoney(minPrice, moneyFormat)}`
              : this.formatMoney(minPrice, moneyFormat);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '{{amount}}';
      const match = formatString.match(placeholderRegex);
      if (!match) return cents;

      let value = '';
      switch (match[1]) {
        case 'amount':
          value = this.formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          value = this.formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = this.formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = this.formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = this.formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = this.formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = this.formatWithDelimiters(cents, 2, ',', '.');
      }

      return formatString.replace(placeholderRegex, value);
    }

    formatWithDelimiters(number, precision, thousands, decimal) {
      if (number == null || number === '') return '0';

      const num = Number(number);
      const fixedNumber = num.toFixed(precision);
      const parts = fixedNumber.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
	const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
